import { ACCEPTING_ORDER_ID, BECOME_BRAND_ID, BRAND_POLICIES_ID, CANCELING_AN_ORDER_ID, CONTACTING_MY_RETAILER_ID, CONTACT_A_BRAND_ID, DISPUTE_A_RETAILER_COMPLAINT_ID, EU_DSA_ID, FAIRE_ACCOUNT_SECURITY_ID, FAIRE_COST_ID, HOW_AM_I_NOTIFIED_NEW_ORDERS_ID, HOW_DO_NET_60_TERMS_WORK_ID, HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID, ISSUE_WITH_MY_ORDER_PAYOUT_ID, MAKE_A_RETURN_ID, NAM_SELL_ON_FAIRE_ID, NON_NAM_SELL_ON_FAIRE_ID, ORDER_INVOICE_ID, ORDER_STATUS_ID, PAYOUT_AUSTRALIAN_ID, PAYOUT_CALCULATED_ID, PAYOUT_CANADIAN_ID, PAYOUT_EUROPEAN_ID, REPORT_DAMAGED_MISSING_ID, RETAILER_WHAT_IS_FAIRE_ID, SETTING_UP_PAYOUT_ID, TAX_FORM_1099_ID, TROUBLESHOOTING_WITH_ADYEN_ID, WHERE_IS_FAIRE_AVAILABLE_ID, WORD_FROM_CEO_ID } from "@faire/help-center-utils/articleIds";
import { Article } from "@faire/help-center-utils/articles";
import { useStrictLocalization } from "@faire/web/common/localization";
export var useArticles = function useArticles() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = {
    GettingStarted: {
      COMPLETING_ONBOARDING_FORM: new Article({
        name: strictLocalize({
          id: "C6NF6S",
          defaultMessage: [{
            "type": 0,
            "value": "Preencher o meu formulário de integração"
          }]
        }),
        id: "360039212391"
      }),
      UPLOAD_FIRST_CATALOG: new Article({
        name: strictLocalize({
          id: "AlDz2c",
          defaultMessage: [{
            "type": 0,
            "value": "Carregar o seu catálogo de produtos"
          }]
        }),
        id: "4416016600347"
      }),
      RESELLER_ID: new Article({
        name: strictLocalize({
          id: "POZmQR",
          defaultMessage: [{
            "type": 0,
            "value": "Preciso de um ID de revendedor?"
          }]
        }),
        id: "360016203651"
      }),
      BRICK_AND_MORTAR: new Article({
        name: strictLocalize({
          id: "HlhWGa",
          defaultMessage: [{
            "type": 0,
            "value": "E se eu não tiver uma loja física?"
          }]
        }),
        id: "360016111231"
      }),
      WORD_FROM_CEO: new Article({
        name: strictLocalize({
          id: "p2eAyI",
          defaultMessage: [{
            "type": 0,
            "value": "Algumas palavras do nosso CEO"
          }]
        }),
        id: WORD_FROM_CEO_ID
      }),
      OPEN_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "kG9smm",
          defaultMessage: [{
            "type": 0,
            "value": "Opening with Faire"
          }]
        }),
        id: "4645924980763"
      })
    },
    MyOrders: {
      HOW_AM_I_NOTIFIED_NEW_ORDERS: new Article({
        name: strictLocalize({
          id: "DDqsse",
          defaultMessage: [{
            "type": 0,
            "value": "Como é que me notificam sobre novas encomendas?"
          }]
        }),
        id: HOW_AM_I_NOTIFIED_NEW_ORDERS_ID
      }),
      HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCT: new Article({
        name: strictLocalize({
          id: "FLONHc",
          defaultMessage: [{
            "type": 0,
            "value": "Como devo vender os meus produtos na Faire?"
          }]
        }),
        id: HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCTS_ID
      }),
      BUSINESS_PROFILE: new Article({
        name: strictLocalize({
          id: "uNwAAN",
          defaultMessage: [{
            "type": 0,
            "value": "Que informações são necessárias para o meu perfil de loja?"
          }]
        }),
        id: "360035578692"
      }),
      SYNC_SQUARE_POS: new Article({
        name: strictLocalize({
          id: "CuRF0T",
          defaultMessage: [{
            "type": 0,
            "value": "Integrar o meu sistema PDV com a Faire"
          }]
        }),
        id: "360037248712"
      }),
      FAIRE_PROTECTION: new Article({
        name: strictLocalize({
          id: "ymeN0d",
          defaultMessage: [{
            "type": 0,
            "value": "O que é o Faire Protection?"
          }]
        }),
        id: "360016111511"
      }),
      REPORT_DAMAGED_MISSING: new Article({
        name: strictLocalize({
          id: "v9kPYq",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso comunicar artigos danificados ou em falta?"
          }]
        }),
        id: REPORT_DAMAGED_MISSING_ID
      }),
      ORDER_STATUS: new Article({
        name: strictLocalize({
          id: "t0xr1I",
          defaultMessage: [{
            "type": 0,
            "value": "Quando receberei as minhas encomendas?"
          }]
        }),
        id: ORDER_STATUS_ID
      }),
      ORDER_RETURNED_TO_SENDER: new Article({
        name: strictLocalize({
          id: "9S0FTQ",
          defaultMessage: [{
            "type": 0,
            "value": "A encomenda foi devolvida ao remetente"
          }]
        }),
        id: "26594585812891"
      }),
      ORDER_QUESTIONS: new Article({
        name: strictLocalize({
          id: "9LqEo1",
          defaultMessage: [{
            "type": 0,
            "value": "Perguntas sobre um artigo"
          }]
        }),
        id: "360006953111"
      }),
      BRAND_MINIMUMS: new Article({
        name: strictLocalize({
          id: "w5vD/I",
          defaultMessage: [{
            "type": 0,
            "value": "O que são mínimos de encomenda?"
          }]
        }),
        id: "360016302912"
      }),
      CANCELING_AN_ORDER: new Article({
        name: strictLocalize({
          id: "0VnS38",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso cancelar uma encomenda?"
          }]
        }),
        id: CANCELING_AN_ORDER_ID
      }),
      CONTACT_A_BRAND: new Article({
        name: strictLocalize({
          id: "SjOF+W",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso contactar uma marca na Faire?"
          }]
        }),
        id: CONTACT_A_BRAND_ID
      })
    },
    ManageMyShop: {
      ADD_EDIT_PRODUCTS: new Article({
        name: strictLocalize({
          id: "9Rgpw6",
          defaultMessage: [{
            "type": 0,
            "value": "Como faço para adicionar ou editar produtos?"
          }]
        }),
        id: "360006829831"
      }),
      BRAND_PROMOTION_CALCULATED: new Article({
        name: strictLocalize({
          id: "/rgb2v",
          defaultMessage: [{
            "type": 0,
            "value": "Como são calculadas as promoções?"
          }]
        }),
        id: "360032489472"
      }),
      CUSTOMIZE_MY_PRODUCT_TRANSLATIONS: new Article({
        name: strictLocalize({
          id: "5p35uh",
          defaultMessage: [{
            "type": 0,
            "value": "Posso personalizar as traduções dos meus produtos?"
          }]
        }),
        id: "7652446722331"
      }),
      CURRENCY_SPECIFIC_PRICING: new Article({
        name: strictLocalize({
          id: "W+2iJv",
          defaultMessage: [{
            "type": 0,
            "value": "Preços de acordo com uma moeda específica"
          }]
        }),
        id: "360055558732"
      }),
      SETTING_PRODUCT_INVENTORY_LEVELS: new Article({
        name: strictLocalize({
          id: "2saxOG",
          defaultMessage: [{
            "type": 0,
            "value": "Definir os meus níveis de inventário dos produtos"
          }]
        }),
        id: "360045187791"
      }),
      ARRANGE_MY_SHOP_LISTINGS: new Article({
        name: strictLocalize({
          id: "kspgKw",
          defaultMessage: [{
            "type": 0,
            "value": "Como organizo as listagens da minha loja?"
          }]
        }),
        id: "360039477271"
      }),
      WHAT_IS_EXCLUSIVITY_PROGRAM: new Article({
        name: strictLocalize({
          id: "Ddnv4m",
          defaultMessage: [{
            "type": 0,
            "value": "O que é o programa Exclusivity?"
          }]
        }),
        id: "18543447335451"
      })
    },
    Referrals: {
      CAN_I_REFER_BRANDS_TO_FAIRE: new Article({
        name: strictLocalize({
          id: "TG9PtX",
          defaultMessage: [{
            "type": 0,
            "value": "Posso convidar marcas para a Faire?"
          }]
        }),
        id: "4404937922587"
      }),
      USE_REFERRAL_PROMOTION: new Article({
        name: strictLocalize({
          id: "FJ+m6x",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso usar uma promoção de convite de uma marca?"
          }]
        }),
        id: "360034300092"
      })
    },
    OptimizingMyPage: {
      COVER_IMAGE_GUIDELINES: new Article({
        name: strictLocalize({
          id: "fXnXFB",
          defaultMessage: [{
            "type": 0,
            "value": "Orientações para as imagens de capa"
          }]
        }),
        id: "360016791851"
      }),
      PRODUCT_PHOTOGRAPHY_GUIDELINES: new Article({
        name: strictLocalize({
          id: "YINiMH",
          defaultMessage: [{
            "type": 0,
            "value": "Orientações para as fotografias de produtos"
          }]
        }),
        id: "360016568092"
      }),
      IMAGE_SIZE_REQUIREMENTS: new Article({
        name: strictLocalize({
          id: "lXeU3d",
          defaultMessage: [{
            "type": 0,
            "value": "Requisitos de tamanho de imagem"
          }]
        }),
        id: "360032130371"
      }),
      BRAND_STORY_GUIDELINES: new Article({
        name: strictLocalize({
          id: "d3h1Ep",
          defaultMessage: [{
            "type": 0,
            "value": "Orientações relativas à história da marca"
          }]
        }),
        id: "360026756912"
      }),
      ADD_VIDEO: new Article({
        name: strictLocalize({
          id: "LJd4Gb",
          defaultMessage: [{
            "type": 0,
            "value": "Posso adicionar um vídeo à minha loja?"
          }]
        }),
        id: "360054846452"
      })
    },
    InvoicesAndBilling: {
      RECEIVE_ORDER_INVOICE: new Article({
        name: strictLocalize({
          id: "X9dXUE",
          defaultMessage: [{
            "type": 0,
            "value": "Vou receber uma fatura da encomenda?"
          }]
        }),
        id: "4408351766171"
      }),
      PRODUCT_REPORT: new Article({
        name: strictLocalize({
          id: "DE+DLf",
          defaultMessage: [{
            "type": 0,
            "value": "E se um revendedor indicar que os meus produtos estão em falta ou danificados?"
          }]
        }),
        id: "360033568051"
      }),
      PAYOUT_CALCULATED: new Article({
        name: strictLocalize({
          id: "eE3x7A",
          defaultMessage: [{
            "type": 0,
            "value": "Como é calculado o meu pagamento?"
          }]
        }),
        id: PAYOUT_CALCULATED_ID
      }),
      PAYOUT_EUROPEAN: new Article({
        name: strictLocalize({
          id: "OiNzBj",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso configurar os pagamentos para uma conta bancária europeia?"
          }]
        }),
        id: PAYOUT_EUROPEAN_ID
      }),
      PAYOUT_AUSTRALIAN: new Article({
        name: strictLocalize({
          id: "NsyCP6",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso configurar os pagamentos para uma conta bancária australiana?"
          }]
        }),
        id: PAYOUT_AUSTRALIAN_ID
      }),
      PAYOUT_CANADIAN: new Article({
        name: strictLocalize({
          id: "M1uK1z",
          defaultMessage: [{
            "type": 0,
            "value": "Pagamentos a marcas canadianas"
          }]
        }),
        id: PAYOUT_CANADIAN_ID
      }),
      ISSUE_WITH_MY_ORDER_PAYOUT: new Article({
        name: strictLocalize({
          id: "GeTSEg",
          defaultMessage: [{
            "type": 0,
            "value": "Problema com o pagamento da minha encomenda"
          }]
        }),
        id: ISSUE_WITH_MY_ORDER_PAYOUT_ID
      }),
      TAX_FORM_1099: new Article({
        name: strictLocalize({
          id: "P/vdrr",
          defaultMessage: [{
            "type": 0,
            "value": "Vou receber um formulário fiscal 1099-K?"
          }]
        }),
        id: TAX_FORM_1099_ID
      }),
      SETTING_UP_PAYOUT: new Article({
        name: strictLocalize({
          id: "qkrW6t",
          defaultMessage: [{
            "type": 0,
            "value": "Configurar a sua conta de pagamento"
          }]
        }),
        id: SETTING_UP_PAYOUT_ID
      }),
      TROUBLESHOOTING_WITH_ADYEN: new Article({
        name: strictLocalize({
          id: "ipXayn",
          defaultMessage: [{
            "type": 0,
            "value": "Resolução de problemas com a Adyen"
          }]
        }),
        id: TROUBLESHOOTING_WITH_ADYEN_ID
      }),
      PAYOUT_ISSUE: new Article({
        name: strictLocalize({
          id: "GeTSEg",
          defaultMessage: [{
            "type": 0,
            "value": "Problema com o pagamento da minha encomenda"
          }]
        }),
        id: "360006915532"
      }),
      TAX_INFORMATION: new Article({
        name: strictLocalize({
          id: "/xy/gD",
          defaultMessage: [{
            "type": 0,
            "value": "Configuração de informações fiscais"
          }]
        }),
        id: "360038950092"
      }),
      NAM_SELL_ON_FAIRE: new Article({
        name: strictLocalize({
          id: "ztJJ3l",
          defaultMessage: [{
            "type": 0,
            "value": "Quais são os custos de vender na Faire se a minha marca estiver localizada na América do Norte?"
          }]
        }),
        id: NAM_SELL_ON_FAIRE_ID
      }),
      NON_NAM_SELL_ON_FAIRE: new Article({
        name: strictLocalize({
          id: "0wp1lr",
          defaultMessage: [{
            "type": 0,
            "value": "Quais são os custos de vender na Faire se a minha marca estiver localizada fora da América do Norte?"
          }]
        }),
        id: NON_NAM_SELL_ON_FAIRE_ID
      })
    },
    Account: {
      ORDER_ISSUE: new Article({
        name: strictLocalize({
          id: "CuhRSF",
          defaultMessage: [{
            "type": 0,
            "value": "Porque não consigo ver a encomenda do meu revendedor na minha conta?"
          }]
        }),
        id: "4415920212123"
      }),
      CANNOT_FIND_ORDER_NUMBER: new Article({
        name: strictLocalize({
          id: "BBAJ+h",
          defaultMessage: [{
            "type": 0,
            "value": "Porque não consigo encontrar o número de encomenda de um revendedor?"
          }]
        }),
        id: "4402385627163"
      }),
      NOT_OPEN: new Article({
        name: strictLocalize({
          id: "nWFeyz",
          defaultMessage: [{
            "type": 0,
            "value": "Ainda não estamos abertos. Posso encomendar na mesma?"
          }]
        }),
        id: "360016111571"
      }),
      ACCOUNT_EMAIL: new Article({
        name: strictLocalize({
          id: "yV7GVR",
          defaultMessage: [{
            "type": 0,
            "value": "Alterar o meu e-mail de início de sessão"
          }]
        }),
        id: "360016302272"
      }),
      MANAGE_TEAMS: new Article({
        name: strictLocalize({
          id: "Z1h57J",
          defaultMessage: [{
            "type": 0,
            "value": "Criar a sua equipa na Faire"
          }]
        }),
        id: "8675579278619"
      }),
      EMAIL_NOTIFICATIONS: new Article({
        name: strictLocalize({
          id: "Xbq6xK",
          defaultMessage: [{
            "type": 0,
            "value": "Posso cancelar a subscrição de e-mails específicos da Faire?"
          }]
        }),
        id: "360059197351"
      }),
      EMAIL_PREFERENCES: new Article({
        name: strictLocalize({
          id: "o547a2",
          defaultMessage: [{
            "type": 0,
            "value": "Configurar as preferências de e-mail"
          }]
        }),
        id: "360057278792"
      }),
      RESETTING_PASSWORD: new Article({
        name: strictLocalize({
          id: "3o8L8n",
          defaultMessage: [{
            "type": 0,
            "value": "Redefinir a minha palavra-passe"
          }]
        }),
        id: "360019610312"
      }),
      WHAT_IS_EXCLUSIVITY: new Article({
        name: strictLocalize({
          id: "x+S067",
          defaultMessage: [{
            "type": 0,
            "value": "O que é a exclusividade?"
          }]
        }),
        id: "19903209185947"
      })
    },
    FaireDirect: {
      ORDER_COMMISSION: new Article({
        name: strictLocalize({
          id: "s4fd/u",
          defaultMessage: [{
            "type": 0,
            "value": "A minha encomenda Direct tem comissão. O que aconteceu?"
          }]
        }),
        id: "360031800672"
      }),
      ZERO_COMMISSION: new Article({
        name: strictLocalize({
          id: "GTHgGi",
          defaultMessage: [{
            "type": 0,
            "value": "Política do Faire Direct referente aos 0% de comissão"
          }]
        }),
        id: "360031800672"
      }),
      EMAIL_CAMPAIGN: new Article({
        name: strictLocalize({
          id: "4SUKRT",
          defaultMessage: [{
            "type": 0,
            "value": "O que é uma campanha de e-mail?"
          }]
        }),
        id: "360038731612"
      }),
      EMAIL_AUTOMATIONS: new Article({
        name: strictLocalize({
          id: "YvFUHb",
          defaultMessage: [{
            "type": 0,
            "value": "O que são automatizações de e-mail?"
          }]
        }),
        id: "360034668751"
      }),
      FAIRE_DIRECT: new Article({
        name: strictLocalize({
          id: "zTqoXs",
          defaultMessage: [{
            "type": 0,
            "value": "O que é o Faire Direct?"
          }]
        }),
        id: "360032132391"
      }),
      FD_ELIGIBLE: new Article({
        name: strictLocalize({
          id: "zbXaBM",
          defaultMessage: [{
            "type": 0,
            "value": "Quem é elegível para encomendar através da Faire Direct?"
          }]
        }),
        id: "360032149291"
      }),
      FD_LINK: new Article({
        name: "How do I use my Direct Link?",
        id: "360032133351"
      })
    },
    FulfillingOrders: {
      SPLIT_ATS_ORDER: new Article({
        name: strictLocalize({
          id: "7DQaFp",
          defaultMessage: [{
            "type": 0,
            "value": "Como dividir uma encomenda ATS"
          }]
        }),
        id: "360060488431"
      }),
      SPLIT_PREORDER: new Article({
        name: strictLocalize({
          id: "5Pei21",
          defaultMessage: [{
            "type": 0,
            "value": "Como dividir uma pré-encomenda"
          }]
        }),
        id: "360060414111"
      }),
      ACCEPTING_ORDER: new Article({
        name: strictLocalize({
          id: "osVMG8",
          defaultMessage: [{
            "type": 0,
            "value": "Aceitar uma encomenda"
          }]
        }),
        id: ACCEPTING_ORDER_ID
      }),
      COMMERCIAL_INVOICE: new Article({
        name: strictLocalize({
          id: "WCJyt7",
          defaultMessage: [{
            "type": 0,
            "value": "Como crio uma fatura comercial"
          }]
        }),
        id: "4404314652059"
      }),
      FULFILLING_ORDER: new Article({
        name: strictLocalize({
          id: "hE2Nbm",
          defaultMessage: [{
            "type": 0,
            "value": "Não consigo satisfazer uma encomenda"
          }]
        }),
        id: "360007184831"
      }),
      UNDERSTAND_ORDER_STATUS: new Article({
        name: strictLocalize({
          id: "5R1ZVj",
          defaultMessage: [{
            "type": 0,
            "value": "Informações sobre o estado da encomenda"
          }]
        }),
        id: ORDER_INVOICE_ID
      }),
      CAN_RETAILER_CANCEL_ORDER: new Article({
        name: strictLocalize({
          id: "0UcJaN",
          defaultMessage: [{
            "type": 0,
            "value": "Os revendedores podem cancelar as encomendas?"
          }]
        }),
        id: "360023102031"
      }),
      SHIPPING_ORDER: new Article({
        name: strictLocalize({
          id: "LTM3/z",
          defaultMessage: [{
            "type": 0,
            "value": "Enviar uma encomenda"
          }]
        }),
        id: "360023300451"
      }),
      SETTING_OUT_OF_STOCK: new Article({
        name: strictLocalize({
          id: "kEJsXY",
          defaultMessage: [{
            "type": 0,
            "value": "Definir artigos como esgotados ou descontinuados"
          }]
        }),
        id: "360006911352"
      }),
      SHIP_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "72y5ni",
          defaultMessage: [{
            "type": 0,
            "value": "Enviar com a Faire"
          }]
        }),
        id: "360030933131"
      }),
      LABEL_ISSUES: new Article({
        name: strictLocalize({
          id: "oBNgYb",
          defaultMessage: [{
            "type": 0,
            "value": "Porque vejo um erro ao utilizar a funcionalidade Enviar com a Faire"
          }]
        }),
        id: "360040920571"
      }),
      SHIP_ON_YOUR_OWN: new Article({
        name: strictLocalize({
          id: "IlfctE",
          defaultMessage: [{
            "type": 0,
            "value": "Como enviar encomendas por conta própria"
          }]
        }),
        id: "360030933311"
      }),
      SHIPPING_COSTS: new Article({
        name: strictLocalize({
          id: "SPzcuL",
          defaultMessage: [{
            "type": 0,
            "value": "Gerir os custos de envio para outros países"
          }]
        }),
        id: "360040349352"
      }),
      SHIPPING_WORK: new Article({
        name: strictLocalize({
          id: "ybSoRd",
          defaultMessage: [{
            "type": 0,
            "value": "Como funciona o envio?"
          }]
        }),
        id: "4405859125531"
      }),
      ABOUT_SHIPPING: new Article({
        name: strictLocalize({
          id: "1JAZ0s",
          defaultMessage: [{
            "type": 0,
            "value": "E quanto ao envio?"
          }]
        }),
        id: "360016111831"
      }),
      SHIPPING_ADDRESS: new Article({
        name: strictLocalize({
          id: "NAicKW",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso alterar o meu endereço de entrega"
          }]
        }),
        id: "360018235292"
      }),
      CHANGE_SHIPPING_ADDRESS: new Article({
        name: strictLocalize({
          id: "v3+vuS",
          defaultMessage: [{
            "type": 0,
            "value": "Posso alterar o meu endereço após o envio da encomenda?"
          }]
        }),
        id: "360007197951"
      }),
      EDIT_RETAILER_ORDER: new Article({
        name: strictLocalize({
          id: "ArjSpz",
          defaultMessage: [{
            "type": 0,
            "value": "Posso editar a encomenda de um revendedor?"
          }]
        }),
        id: "360053212551"
      })
    },
    ReturnsAndRefunds: {
      MAKE_A_RETURN: new Article({
        name: strictLocalize({
          id: "PTuRfO",
          defaultMessage: [{
            "type": 0,
            "value": "Como efetuo uma devolução?"
          }]
        }),
        id: MAKE_A_RETURN_ID
      }),
      EXTEND_A_RETURN: new Article({
        name: strictLocalize({
          id: "hDezWS",
          defaultMessage: [{
            "type": 0,
            "value": "Posso prolongar o meu prazo de devolução?"
          }]
        }),
        id: "360022876131"
      }),
      CANT_RETURN: new Article({
        name: strictLocalize({
          id: "F85fJa",
          defaultMessage: [{
            "type": 0,
            "value": "Porque não posso devolver os meus artigos?"
          }]
        }),
        id: "360007069352"
      })
    },
    PaymentsAndInvoices: {
      CHANGE_MY_PAYMENT_METHOD: new Article({
        name: strictLocalize({
          id: "sRWcLE",
          defaultMessage: [{
            "type": 0,
            "value": "Alterar o meu método de pagamento"
          }]
        }),
        id: "360018497831"
      }),
      NET_60_TERMS: new Article({
        name: strictLocalize({
          id: "17QDXy",
          defaultMessage: [{
            "type": 0,
            "value": "Como funciona o prazo de pagamento líquido a 60 dias?"
          }]
        }),
        id: HOW_DO_NET_60_TERMS_WORK_ID
      }),
      PAY_INVOICES: new Article({
        name: strictLocalize({
          id: "+8Ngr8",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso pagar as minhas faturas?"
          }]
        }),
        id: "360006920172"
      }),
      INVOICE_DUE: new Article({
        name: strictLocalize({
          id: "r9dmpJ",
          defaultMessage: [{
            "type": 0,
            "value": "Qual é a data de vencimento da minha fatura?"
          }]
        }),
        id: "360006994232"
      }),
      UNDERSTANDING_ORDER_INVOICE: new Article({
        name: strictLocalize({
          id: "COn3iE",
          defaultMessage: [{
            "type": 0,
            "value": "Compreender a fatura da encomenda"
          }]
        }),
        id: "4416125712795"
      }),
      HOW_DO_I_PAY_FOR_ORDERS: new Article({
        name: strictLocalize({
          id: "1k8YBm",
          defaultMessage: [{
            "type": 0,
            "value": "Como pago as encomendas?"
          }]
        }),
        id: "360015892632"
      }),
      HOW_DO_I_CHANGE_MY_BILLING_ADDRESS: new Article({
        name: strictLocalize({
          id: "jdoE1a",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso alterar o endereço de faturação?"
          }]
        }),
        id: "24430827309467"
      })
    },
    INSIDER: {
      INSIDER_BRAND_PARTNERSHIP: new Article({
        name: strictLocalize({
          id: "H8tXRk",
          defaultMessage: [{
            "type": 0,
            "value": "O programa Insider Partnership para marcas"
          }]
        }),
        id: "25213101060123"
      })
    },
    FAQ: {
      RESETTING_PASSWORD: new Article({
        name: strictLocalize({
          id: "3o8L8n",
          defaultMessage: [{
            "type": 0,
            "value": "Redefinir a minha palavra-passe"
          }]
        }),
        id: "360019854651"
      }),
      RETAILER_WHAT_IS_FAIRE: new Article({
        name: strictLocalize({
          id: "lDcCOD",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso começar a comprar na Faire?"
          }]
        }),
        id: RETAILER_WHAT_IS_FAIRE_ID
      }),
      EU_DSA: new Article({
        name: strictLocalize({
          id: "bdi6Mi",
          defaultMessage: [{
            "type": 0,
            "value": "Ponto de contacto único da Lei de Serviços Digitais da UE"
          }]
        }),
        id: EU_DSA_ID
      }),
      HOW_RETURNS_WORK: new Article({
        name: strictLocalize({
          id: "3+R7cy",
          defaultMessage: [{
            "type": 0,
            "value": "Como funcionam as devoluções"
          }]
        }),
        id: "360015892592"
      }),
      FAIRE_INSIDER_US: new Article({
        name: strictLocalize({
          id: "zPGP9w",
          defaultMessage: [{
            "type": 0,
            "value": "Como é que o Insider funciona para revendedores nos EUA?"
          }]
        }),
        id: "4406840862747"
      }),
      FAIRE_INSIDER_EU: new Article({
        name: strictLocalize({
          id: "Ua9ksa",
          defaultMessage: [{
            "type": 0,
            "value": "Como funciona o Insider para revendedores europeus?"
          }]
        }),
        id: "4418050425115"
      }),
      WHERE_IS_FAIRE_AVAILABLE: new Article({
        name: strictLocalize({
          id: "m68Icb",
          defaultMessage: [{
            "type": 0,
            "value": "Onde está disponível a Faire?"
          }]
        }),
        id: WHERE_IS_FAIRE_AVAILABLE_ID
      }),
      BRAND_REFERRAL_PROGRAM_TERMS_CONDITIONS: new Article({
        name: strictLocalize({
          id: "rAW53+",
          defaultMessage: [{
            "type": 0,
            "value": "TERMOS E CONDIÇÕES DO PROGRAMA DE CONVITE DE MARCAS DA FAIRE"
          }]
        }),
        id: "13628687993371"
      }),
      FAIRE_ACCOUNT_SECURITY: new Article({
        name: strictLocalize({
          id: "evS1O1",
          defaultMessage: [{
            "type": 0,
            "value": "Melhores práticas de segurança para a sua conta Faire"
          }]
        }),
        id: FAIRE_ACCOUNT_SECURITY_ID
      })
    },
    FAQForProspectiveBrands: {
      HOW_GET_PAID: new Article({
        name: strictLocalize({
          id: "LYRxSA",
          defaultMessage: [{
            "type": 0,
            "value": "Como recebo os pagamentos?"
          }]
        }),
        id: "360015893272"
      }),
      FAIRE_COST: new Article({
        name: strictLocalize({
          id: "36qrix",
          defaultMessage: [{
            "type": 0,
            "value": "Quanto custa vender na Faire?"
          }]
        }),
        id: FAIRE_COST_ID
      }),
      BECOME_BRAND: new Article({
        name: strictLocalize({
          id: "ICLZE5",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso vender na Faire?"
          }]
        }),
        id: BECOME_BRAND_ID
      })
    },
    International: {
      VAT_WORK_NON_EU_ORDERS: new Article({
        name: strictLocalize({
          id: "XXZP7G",
          defaultMessage: [{
            "type": 0,
            "value": "Como funciona o IVA nas encomendas para países europeus fora da UE?"
          }]
        }),
        id: "4404431808155"
      }),
      PAY_VAT_NON_EU: new Article({
        name: strictLocalize({
          id: "MIkkag",
          defaultMessage: [{
            "type": 0,
            "value": "Como pago o IVA das minhas encomendas nos países europeus fora da UE?"
          }]
        }),
        id: "4404431878683"
      }),
      VAT_WORK_EU_ORDERS: new Article({
        name: strictLocalize({
          id: "ox+alG",
          defaultMessage: [{
            "type": 0,
            "value": "Como funciona o IVA para encomendas na UE?"
          }]
        }),
        id: "360057747911"
      }),
      CANADIAN_RETAILERS: new Article({
        name: strictLocalize({
          id: "2l9kFh",
          defaultMessage: [{
            "type": 0,
            "value": "Começar como um revendedor no Canadá"
          }]
        }),
        id: "360034894292"
      }),
      LOCATION_SHOP_LIVE: new Article({
        name: strictLocalize({
          id: "/BK1wq",
          defaultMessage: [{
            "type": 0,
            "value": "Posso controlar os locais onde a minha loja está ativa?"
          }]
        }),
        id: "360016524391"
      }),
      SELLING: new Article({
        name: strictLocalize({
          id: "vR2146",
          defaultMessage: [{
            "type": 0,
            "value": "Um guia para vender internacionalmente na Faire"
          }]
        }),
        id: "4407511671579"
      }),
      BUY: new Article({
        name: strictLocalize({
          id: "MAingx",
          defaultMessage: [{
            "type": 0,
            "value": "Como comprar internacionalmente na Faire"
          }]
        }),
        id: "4405345083675"
      })
    },
    ContactMyRetailer: {
      CONTACTING_MY_RETAILER: new Article({
        name: strictLocalize({
          id: "53rQbV",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso contactar os meus revendedores na Faire?"
          }]
        }),
        id: CONTACTING_MY_RETAILER_ID
      })
    },
    BrandTermsAndPolicies: {
      DISPUTE_A_RETAILER_COMPLAINT: new Article({
        name: strictLocalize({
          id: "vFNhSP",
          defaultMessage: [{
            "type": 0,
            "value": "Contestar a reclamação de um revendedor"
          }]
        }),
        id: DISPUTE_A_RETAILER_COMPLAINT_ID
      }),
      BRAND_POLICIES: new Article({
        name: strictLocalize({
          id: "lLVQEM",
          defaultMessage: [{
            "type": 0,
            "value": "Políticas de marca"
          }]
        }),
        id: BRAND_POLICIES_ID
      })
    },
    ImportFeesAndDuties: {
      DUTIES_REFUND: new Article({
        name: strictLocalize({
          id: "cgQGPC",
          defaultMessage: [{
            "type": 0,
            "value": "O que acontece quando a Faire cobre os meus direitos aduaneiros de importação?"
          }]
        }),
        id: "4403349101723"
      }),
      USA: new Article({
        name: strictLocalize({
          id: "lc7vKv",
          defaultMessage: [{
            "type": 0,
            "value": "Como funciona o envio para os EUA?"
          }]
        }),
        id: "360031133351"
      }),
      Canada: new Article({
        name: strictLocalize({
          id: "zsTBx4",
          defaultMessage: [{
            "type": 0,
            "value": "Como funciona o envio para o Canadá?"
          }]
        }),
        id: "360057607832"
      }),
      Europe: new Article({
        name: strictLocalize({
          id: "XLscSH",
          defaultMessage: [{
            "type": 0,
            "value": "Importar para a Europa"
          }]
        }),
        id: "360056061932"
      }),
      Australia: new Article({
        name: strictLocalize({
          id: "PXuWXh",
          defaultMessage: [{
            "type": 0,
            "value": "Importação para a Austrália"
          }]
        }),
        id: "6668590967579"
      }),
      EORI: new Article({
        name: strictLocalize({
          id: "93QqWi",
          defaultMessage: [{
            "type": 0,
            "value": "Como posso solicitar um número EORI?"
          }]
        }),
        id: "4409464460187"
      }),
      VAT: new Article({
        name: strictLocalize({
          id: "KVID5a",
          defaultMessage: [{
            "type": 0,
            "value": "Preciso de ter um número para efeitos de IVA?"
          }]
        }),
        id: "4405333889435"
      })
    },
    Integration: {
      SOFTWARE_INTEGRATION_WITH_FAIRE: new Article({
        name: strictLocalize({
          id: "M/W49R",
          defaultMessage: [{
            "type": 0,
            "value": "Integração de software com a Faire"
          }]
        }),
        id: "360037964391"
      }),
      ONBOARDING_WITH_SHOPIFY: new Article({
        name: strictLocalize({
          id: "SDYcWM",
          defaultMessage: [{
            "type": 0,
            "value": "Integração com a Shopify"
          }]
        }),
        id: "4407533398939"
      }),
      CAN_I_INTEGRATE_WITH_SHOPIFY: new Article({
        name: strictLocalize({
          id: "rkM/49",
          defaultMessage: [{
            "type": 0,
            "value": "Posso associar a Faire à Shopify?"
          }]
        }),
        id: "360054245292"
      })
    }
  };
  return articles;
};